import { compose } from 'ramda'
import * as R from 'ramda'
import moment from 'moment'
import { updateAccessToken } from 'app/services/userService/userStorage'
import effects from 'app/effects/effects'
import { createTokenQueue } from './tokenQueue'
import store from 'app/store'
import { logoutUser, updateUserAccessToken } from './store/actions'
import { viewToken, viewMaKey } from './store/reducers/user.reducer'
import {
  accessTokenToAuthorizationHeadersXMode,
  accessAuthorizationHeadersXModeOnly,
} from './authUtils'
import { addExpiresAt } from './tokenHelper'

export const notifymeTokenQueue = createTokenQueue({
  getToken: compose(viewToken, store.getState),
  getMaKey: compose(viewMaKey, store.getState),
  updateAccessToken: (token) => {
    store.dispatch(updateUserAccessToken(token))
    updateAccessToken(token)
  },
  removeToken: () => {
    // TODO: Showing some alert error to feedback to user
    store.dispatch(logoutUser())
  },
  performRefreshToken: () =>
    effects.apis
      .refreshTokenManager()
      .then((token) => Promise.resolve(addExpiresAt(moment(), token)))
      .catch(R.unless(R.propSatisfies(R.isNil, 'response'), Promise.reject)),
  getDate: () => moment().unix(),
})

export const withAuthHeaders =
  (fetch) =>
  (...args) =>
    notifymeTokenQueue.addQueue().then((result) => {
      return fetch(accessTokenToAuthorizationHeadersXMode(result))(...args)
    })

export const withAuthMAModeOnly =
  (fetch) =>
  (...args) => {
    return fetch(accessAuthorizationHeadersXModeOnly())(...args)
  }
